$(document).ready(function(){
$('img[src="https://img.youtube.com/vi/rk4HX9K2fOU/hqdefault.jpg"]').attr(
    'alt',
    'Serene Drains Linear Drains thumbnail'
);

$('img[src="https://img.youtube.com/vi/_7f8aN_cpqY/hqdefault.jpg"]').attr(
    'alt',
    'Serene Drains Square Drains thumbnail'
);

$('img[src="https://img.youtube.com/vi/lDizxALMxAI/hqdefault.jpg"]').attr(
    'alt',
    'Serene Drains Shelves thumbnail'
);

$("h2#pickup-availability-heading:empty").append("<span style='display:none'>.</span>");

setTimeout(() => {
    $("div.jdgm-widget-actions-wrapper>a.jdgm-write-rev-link").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });


$("div.reputon-review-images>img").attr("alt","customer review thumbnail");
}, 1000);
$("button.btn-calc").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
$('img[src="//flooringsupplyshop.com/cdn/shop/files/output-onlinepngtools.png?v=1777395280&width=269"]').attr(
    'alt',
    'Flooring Supply Shop logo'
);

$('input.js-option[type="radio"]').each(function () {
    const $input = $(this);
    const inputId = $input.attr('id');

    const $label = $(`label[for="${inputId}"]`);
    const altText = $label.find('.visually-hidden').first().text().trim();

    const $img = $label.find('img');

    $img.each(function () {
        if (!$(this).attr('alt') || $(this).attr('alt').trim() === '') {
            $(this).attr('alt', altText);
        }
    });
});

$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_serenedrains_drains.jpg?v=1763355875&width=460\"]").attr("alt", "Three metal floor grates with different patterns");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_serenedrains_shelves.jpg?v=1763355896&width=460\"]").attr("alt", "Reed diffuser and candle on tray");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_chameleon.jpg?v=1763355911&width=460\"]").attr("alt", "Stainless steel floor vent cover with slats");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_rai_fix.jpg?v=1763355925&width=460\"]").attr("alt", "Three metal door strike plates with holes");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_atr.jpg?v=1763356355&width=460\"]").attr("alt", "Pack of blue tile spacers and bag of spacers with label");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_ceramic_accessories.jpg?v=1763355950&width=460\"]").attr("alt", "White square sink basin");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_tileware.jpg?v=1763355992&width=460\"]").attr("alt", "Bathroom accessories including soap dish and towel rack");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_smith_paint.jpg?v=1763356023&width=460\"]").attr("alt", "Three large bottles of Swiffer flooring products");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_ti_proboard.jpg?v=1763356051&width=460\"]").attr("alt", "Grey wooden flooring plank");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_clearpath.jpg?v=1763356063&width=460\"]").attr("alt", "Flooring installation kit with underlayment roll, panels, screws, and design samples");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_osb.jpg?v=1763356075&width=460\"]").attr("alt", "Red and black floor drain assembly");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_better_bench.jpg?v=1763356088&width=460\"]").attr("alt", "Metal flooring pieces, various shapes");
$("img[src=\"//flooringsupplyshop.com/cdn/shop/files/homepage_popular_collections_monkey_pads.jpg?v=1763356100&width=460\"]").attr("alt", "Colored Monkey Pads abrasive discs with logo and grit numbers");

$("img[src=\"https://img.youtube.com/vi/rk4HX9K2fOU/hqdefault.jpg\"]").attr("alt", "Ing");
$("img[src=\"https://img.youtube.com/vi/_7f8aN_cpqY/hqdefault.jpg\"]").attr("alt", "Metal air freshener with wavy lines on a reflective surface");
$("img[src=\"https://img.youtube.com/vi/lDizxALMxAI/hqdefault.jpg\"]").attr("alt", "Metal floor grates in silver, gold, and black");
$('input[type="radio"].opt-btn.visually-hidden.js-option[name*="featured_collection"]').each(function () {
    var $input = $(this);

    if ($.trim($input.attr('aria-label') || '') === '') {
        var value = $.trim($input.val() || '');

        if (value) {
            $input.attr('aria-label', value);
        }
    }
});
$('input[type="radio"].opt-btn.visually-hidden.js-option[name*="recommendations"]').each(function () {
    var $input = $(this);

    if ($.trim($input.attr('aria-label') || '') === '') {
        var value = $.trim($input.val() || '');

        if (value) {
            $input.attr('aria-label', value);
        }
    }
});
$('input[type="radio"].opt-btn.visually-hidden.js-option[name*="collection-products"]').each(function () {
    var $input = $(this);

    if ($.trim($input.attr('aria-label') || '') === '') {
        var value = $.trim($input.val() || '');

        if (value) {
            $input.attr('aria-label', value);
        }
    }
});


let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
$("#template--27748903256385__featured_collection_Md7jVm-9942285287745-color-opt-0").attr("aria-label","Enter color");

   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
    
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
$('#tileLength').attr('aria-label', 'Enter Tile Length');
$('#tileWidth').attr('aria-label', 'Enter Tile Width');
$('#areaLength').attr('aria-label', 'Enter Area Length');
$('#areaWidth').attr('aria-label', 'Enter Area Width');
$('#gapSize').attr('aria-label', 'Enter Gap Size');
$('#gapSizeDen').attr('aria-label', 'Enter Gap Size Denominator');
$('#boxSize').attr('aria-label', 'Enter Box Size');
$('#priceInput').attr('aria-label', 'Enter Price');
$('#totalAreaInput').attr('aria-label', 'Enter Total Area');
$('#gapSizeNum').attr('aria-label', 'Enter Gap Size');
$('#gapDecimal').attr('aria-label', 'Enter Gap Decimal');
$('#gapNum').attr('aria-label', 'Enter Gap Numerator');
$('#gapDen').attr('aria-label', 'Enter Gap Denominator');
$('#areaTotal').attr('aria-label', 'Enter Total Area');
$('#heatedFloorSize').attr('aria-label', 'Enter Heated Floor Size');
$('#electricityCost').attr('aria-label', 'Enter Electricity Cost');
$('#dailyHeatingTime').attr('aria-label', 'Enter Daily Heating Time');

});